import moment from 'moment';
import Image from 'next/image';
import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { launchProduct } from '../../../../api-client/my-product';
import { deleteIcon } from '../../../../assets/icons';
import Alert from '../../../elements/alerts';
import Button from '../../../elements/button';
import CalendarModal from '../../../elements/calendar';
import Card from '../../../elements/card';
import Input from '../../../elements/input';
import RadioInput from '../../../elements/radio';

const PublishProductModal = ({ setOpenPublishProductModal, productToken }) => {
  const [selectedInput, setSelectedInput] = useState('date-selection');
  const [closeCalendar, setCloseCalendar] = useState(true);
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const queryClient = useQueryClient();

  const handleChange = inputValue => {
    setSelectedInput(inputValue);
  };

  const handleApply = () => {
    setCloseCalendar(true);
  };

  const productMutate = useMutation(launchProduct, {
    onSuccess: () => {
      queryClient.invalidateQueries('my-products');
      setLoading(false);
      setOpenPublishProductModal(false);
      toast.success('Product Launched Successfully');
      setError(null);
    },
    onError: err => {
      setLoading(false);
      setError(err.response.data.message);
    },
  });

  const publishProduct = React.useCallback(
    data => {
      productMutate.mutate(data);
    },
    [productMutate]
  );

  const handleLaunch = React.useCallback(async () => {
    setLoading(true);

    const formData = {
      productToken,
      launchDate: moment(date.toDateString()).format('MM-DD-YYYY'),
    };

    try {
      const res = await launchProduct(formData);

      queryClient.invalidateQueries('my-products');
      setLoading(false);
      setOpenPublishProductModal(false);
      toast.success('Product Launched Successfully');
      setError(null);
    } catch (error) {
      setLoading(false);
      setError(error.response.data.message);
    }
  }, [date]);

  return (
    <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40">
      {!closeCalendar && (
        <CalendarModal
          date={date}
          setDate={setDate}
          closeCalendar={setCloseCalendar}
          selectRange={false}
          handleApply={handleApply}
        />
      )}
      <Card>
        <form
          onSubmit={e => {
            e.preventDefault();
            setLoading(true);

            handleLaunch();
          }}
        >
          <div className="flex items-center justify-between">
            <div></div>
            <div>
              <button onClick={() => setOpenPublishProductModal(false)}>
                <Image
                  src={deleteIcon}
                  alt="Stakecut | Affiliate Marketplace"
                />
              </button>
            </div>
          </div>
          <div>
            <h2 className="text-md font-medium">Publish Product</h2>
          </div>
          {/* {error && <Alert type={'error'} message={error} />} */}
          {error && <Alert type="error" message={error} />}
          <div className="mb-7 mt-10">
            <p>
              Your product has been verified by the Stakecut team. You can
              either choose to schedule your product launch or publish
              immediately.
            </p>
          </div>
          <div>
            <h3 className="font-medium">Date to Launch product</h3>
            <Input
              placeholder="MM/DD/YYY"
              type="text"
              value={
                date !== ''
                  ? moment(date.toDateString()).format('DD/MM/YYYY')
                  : date
              }
              onFocus={() => setCloseCalendar(false)}
            />
          </div>
          <div className="mt-6">
            <div>
              <RadioInput
                name="publish-type"
                value="date-selection"
                label="Select a Product Launch date"
                isChecked={selectedInput === 'date-selection'}
                onChange={() => selectedInput('date-selection')}
                id="date-selection"
                htmlFor="date-selection"
                onClick={() => setSelectedInput('date-selection')}
              />
            </div>
            <div className="mt-3">
              <RadioInput
                name="select-launch-date"
                value="publish-immediately"
                label="Publish product immediately "
                isChecked={selectedInput === 'publish-immediately'}
                handleChange={() => selectedInput('publsih-immediately')}
                id="publish-immediately"
                htmlFor="publish-immediately"
                onClick={() => {
                  setSelectedInput('publish-immediately');
                  setDate(new Date());
                }}
              />
            </div>
          </div>
          <div className="mt-6">
            <div className="flex items-center flex-col md:flex-row flex-wrap">
              <div className="w-full md:w-64">
                <Button
                  className="w-full md:w-64 px-3 py-5 bg-primary text-light hover:opacity-95 transition-all ease-linear duration-500"
                  label="Acccept"
                  loading={loading}
                  type="submit"
                />
              </div>
              <div className="ml-0 md:ml-2 mt-3 md:mt-0 w-full md:w-64">
                <Button
                  className="border-primary border w-full md:w-64 px-3 py-5"
                  label="Cancel"
                  onClick={() => setOpenPublishProductModal(false)}
                />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </section>
  );
};

export default PublishProductModal;
